import { lazy } from 'react';
import { Route } from 'react-router-dom';
import { SupplierLayout } from '@/layouts/SupplierLayout';
import { ProtectedRoute, RoleRoute } from '@/components/common/routes';

const SupplierSettingsPage = lazy(() =>
  import('@/pages/supplier/SupplierSettingsPage').then((m) => ({ default: m.SupplierSettingsPage }))
);
const DashboardPage = lazy(() => import('@/pages/supplier/DashboardPage').then((m) => ({ default: m.DashboardPage })));
const AccountSettingsPage = lazy(() =>
  import('@/pages/supplier/AccountSettingsPage').then((m) => ({ default: m.AccountSettingsPage }))
);
const TourPage = lazy(() => import('@/pages/supplier/TourPage').then((m) => ({ default: m.TourPage })));
const CalendarPage = lazy(() => import('@/pages/supplier/CalendarPage').then((m) => ({ default: m.CalendarPage })));
const AnalyticsPage = lazy(() => import('@/pages/supplier/AnalyticsPage').then((m) => ({ default: m.AnalyticsPage })));
const ReportsPage = lazy(() => import('@/pages/supplier/Reports').then((m) => ({ default: m.ReportsPage })));
const WalletPage = lazy(() => import('@/pages/supplier/WalletPage').then((m) => ({ default: m.WalletPage })));
const InboxPage = lazy(() => import('@/pages/supplier/InboxPage').then((m) => ({ default: m.InboxPage })));
const ActivitiesPage = lazy(() =>
  import('@/pages/supplier/ActivitiesPage').then((m) => ({ default: m.ActivitiesPage }))
);
const SupplierBookingsPage = lazy(() =>
  import('@/pages/supplier/BookingsPage').then((m) => ({ default: m.BookingsPage }))
);
const TeamPage = lazy(() => import('@/pages/supplier/TeamPage').then((m) => ({ default: m.TeamPage })));
const PromosPage = lazy(() => import('@/pages/supplier/PromosPage').then((m) => ({ default: m.PromosPage })));
const ChatPage = lazy(() => import('@/pages/supplier/ChatPage').then((m) => ({ default: m.ChatPage })));
const TicketScannerPage = lazy(() =>
  import('@/pages/supplier/TicketScannerPage').then((m) => ({ default: m.TicketScannerPage }))
);
const TourDetailsPage = lazy(() =>
  import('@/pages/supplier/TourDetailsPage').then((m) => ({ default: m.TourDetailsPage }))
);

export const supplierRoutes = (
  <>
    <Route path="/supplier/setup" element={<SupplierSettingsPage />} />
    <Route element={<ProtectedRoute />}>
      <Route element={<SupplierLayout />}>
        <Route path="/supplier/dashboard" element={<DashboardPage />} />
        <Route path="/supplier/account-settings" element={<AccountSettingsPage />} />
        <Route path="/supplier/supplier-settings" element={<SupplierSettingsPage />} />
        <Route path="/supplier/calendar" element={<CalendarPage />} />
        <Route
          path="/supplier/activities"
          element={
            <RoleRoute allowedRoles={['individual', 'agency']}>
              <ActivitiesPage />
            </RoleRoute>
          }
        />
        <Route
          path="/supplier/bookings"
          element={
            <RoleRoute allowedRoles={['individual', 'agency']}>
              <SupplierBookingsPage />
            </RoleRoute>
          }
        />
        <Route
          path="/supplier/scanner"
          element={
            <RoleRoute allowedRoles={['individual', 'agency']}>
              <TicketScannerPage />
            </RoleRoute>
          }
        />
        <Route
          path="/supplier/activities/new"
          element={
            <RoleRoute allowedRoles={['individual', 'agency']}>
              <TourPage />
            </RoleRoute>
          }
        />
        <Route
          path="/supplier/activities/:id/edit"
          element={
            <RoleRoute allowedRoles={['individual', 'agency']}>
              <TourPage />
            </RoleRoute>
          }
        />
        <Route
          path="/supplier/activities/:id"
          element={
            <RoleRoute allowedRoles={['individual', 'agency']}>
              <TourDetailsPage />
            </RoleRoute>
          }
        />
        <Route
          path="/supplier/promotions"
          element={
            <RoleRoute allowedRoles={['individual', 'agency']}>
              <PromosPage />
            </RoleRoute>
          }
        />
        <Route
          path="/supplier/team"
          element={
            <RoleRoute allowedRoles={['agency']}>
              <TeamPage />
            </RoleRoute>
          }
        />
        <Route
          path="/supplier/analytics"
          element={
            <RoleRoute allowedRoles={['individual', 'agency']}>
              <AnalyticsPage />
            </RoleRoute>
          }
        />
        <Route
          path="/supplier/reports"
          element={
            <RoleRoute allowedRoles={['individual', 'agency']}>
              <ReportsPage />
            </RoleRoute>
          }
        />
        <Route
          path="/supplier/wallet"
          element={
            <RoleRoute allowedRoles={['individual', 'agency']}>
              <WalletPage />
            </RoleRoute>
          }
        />
        <Route path="/supplier/messages" element={<InboxPage />} />
        <Route path="/supplier/chat" element={<ChatPage />} />
        <Route path="/supplier/chat/:supplierId" element={<ChatPage />} />
      </Route>
    </Route>
  </>
);
